import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {IGetNucleoFamiliar, IPerfilSisbenUsuario, ISisbenConsultaResponse} from "../shared/interface/consultaSisben";
import {Observable} from "rxjs";
import {IPuntajeSisben} from "../shared/interface/sisben";

@Injectable({
  providedIn: 'root'
})
export class DatasetDinamicoService {
  private readonly baseUrl: string = `${environment.apiUrl}/api/datasets-dinamicos/sisben`;

  constructor(private http: HttpClient) {
  }

  consultaSisben(tipoIdentificacion: number, identificacion: string):Observable<ISisbenConsultaResponse[]> {
    const url = `${this.baseUrl}/consulta`;
    const params = new HttpParams()
      .set('tipoIdentificacion', tipoIdentificacion)
      .set('search', identificacion);
    return this.http.get<ISisbenConsultaResponse[]>(url, {params});
  }

  getPerfilSisbenById(id: number):Observable<IPerfilSisbenUsuario> {
    const url = `${this.baseUrl}/perfil/${id}`;
    return this.http.get<IPerfilSisbenUsuario>(url);
  }

  getNucleoFamiliarByJefeFamiliaId(jefeFamiliaId: number):Observable<IGetNucleoFamiliar[]> {
    const url = `${this.baseUrl}/nucleo-familiar/${jefeFamiliaId}`;
    return this.http.get<IGetNucleoFamiliar[]>(url);
  }

  getPuntajeSisben(id:number): Observable<IPuntajeSisben> {
    return this.http.get<IPuntajeSisben>(`${this.baseUrl}/${id}/puntaje`);
  }
}

